import { Dispatch, FC, SetStateAction, useMemo } from "react";
import {
    SearchBarDataHandler,
    SearchBar,
} from "../../../../assets/components/SearchBar/SearchBar";
import { OptionList } from "../../../../assets/helpers/helpers";
import { Products } from "../../../../models/models";

interface Props {
    products?: Products;
    dataHandler: Dispatch<SetStateAction<SearchBarDataHandler>>;
}
const LicenseKeysMigratedSearchBar: FC<Props> = ({ products, dataHandler }) => {
    const productsOptionList: OptionList = useMemo(() => {
        return products?.map(({ name, id }) => {
            return {
                id,
                name,
            };
        }) as OptionList;
    }, [products]);

    const migratedLicenseOptionList: OptionList = useMemo(() => {
        return [
            {
                id: 0,
                name: "Is Migrated",
                data: true,
            },
            {
                id: 1,
                name: "Is Not migrated",
                data: false,
            },
        ];
    }, []);

    return (
        <SearchBar
            productOptions={productsOptionList}
            dataHandler={dataHandler}
            searchInput={{
                placeholder: "License key",
            }}
            searchByOrderId={{
                placeholder: "Order ID",
            }}
            migratedLicenseOptions={migratedLicenseOptionList}
            showComponents={{
                dataPikerNextRebillDate: true,
            }}
        />
    );
};

export default LicenseKeysMigratedSearchBar;
